export const DEVICE_ACTIVE_DURATION_THRESHOLD_IN_SECONDS = 660;
export const DEVICE_DISCONNECTED_DURATION_THRESHOLD_IN_SECONDS = 660;
export default DEVICE_ACTIVE_DURATION_THRESHOLD_IN_SECONDS;
